export interface Agreement {
  country: string;
  status: string;
  title: string;
  organizations?: string[];
}

export interface ContinentData {
  name: string;
  countries: Agreement[];
}

export const perjanjianInternasionalAgreements: ContinentData[] = [
  {
    name: "AFRIKA",
    countries: [
      {
        country: "MOZAMBIK",
        status: "Proses Perpanjangan",
        title:
          "Memorandum of Understanding between the Indonesian National Police and the Mozambique National Police on Preventing and Combating Transnational Crimes and Capacity Building",
      },
      {
        country: "NAMIBIA",
        status: "Masih Berlaku",
        title:
          "Memorandum of Understanding between the Indonesian National Police and the Ministry of Interior of the Republic of the Sudan on Preventing and Combating Transnational Crimes and Cooperation in Capacity Building",
      },
      {
        country: "RWANDA",
        status: "Siap Ditandatangani",
        title:
          "Memorandum of Understanding between the Indonesia National Police and the Rwanda national Police on Cooperation in Preventing and Combating Transnational Crimes and Enhancing Capacity Building",
      },
      {
        country: "SUDAN",
        status: "Proses perpanjangan",
        title:
          "Memorandum of Understanding between the Indonesian National Police and the Ministry of Interior of the Republic of the Sudan on Preventing and Combating Transnational Crimes and Cooperation in Capacity Building",
      },
    ],
  },
  {
    name: "AMERIKA",
    countries: [
      {
        country: "AMERIKA SERIKAT",
        status: "Beragam Status",
        title: "Berbagai Perjanjian dengan Lembaga Berbeda",
        organizations: [
          "DSS-ATA: Memorandum of Intent between the Indonesian National Police and the Department of State of the United States of America on Antiterrorism Capacity Building (Masih Berlaku)",
          "FBI: Letter of Intent between the Indonesian National Police and Federal Bureau of Investigation of The United States of America On Mutual Cooperation in Capacity Building and Preventing and Combating Transnational Crime (Habis Masa Berlaku)",
          "ICITAP: Letter of Intent between the Indonesian National Police and US Department of Justice on Law Enforcement Development Assistance (Diberhentikan)",
          "ICE: Letter of Intent between the Criminal Investigation Department of The Indonesian National Police of The Republic of Indonesia And U.S. Immigration and Customs Enforcement of The Department of Homeland Security of The United States of America On Collaborative Actions in The Fight Against Transnational Crime (Proses Perjanjian)",
        ],
      },
      {
        country: "KANADA",
        status: "Masih Berlaku",
        title:
          "Memorandum of Understanding Between the Indonesian National Police and The Royal Canadian Mounted Police Concerning the Cooperation in Preventing and Combating Transnational Organized Crimes and Capacity Building",
      },
      {
        country: "MEKSIKO",
        status: "Diberhentikan",
        title:
          "Memorandum of Understanding between the Indonesian National Police of the Republic of Indonesia and the Office of the Attorney General of The Republic of The United Mexican States on Combating transnational Crimes and Capacity Building",
      },
    ],
  },
  {
    name: "ASIA",
    countries: [
      {
        country: "BRUNEI DARUSSALAM",
        status: "Masih Berlaku",
        title:
          "Memorandum of Understanding on Cooperation in Preventing and Combating Transnational Crimes",
      },
      {
        country: "FILIPINA",
        status: "Masih Berlaku",
        title:
          "Memorandum of Understanding on Cooperation in Preventing and Combating Transnational Crimes",
      },
      {
        country: "IRAN",
        status: "Masih Berlaku",
        title:
          "Letter of Intent between the Indonesian National Police and the Law Enforcement Force of the Islamic Republic of Iran on People Cooperation",
      },
      {
        country: "PALESTINA",
        status: "Masih Berlaku",
        title:
          "Memorandum of Understanding Between the Indonesia National Police and the Palestinian Civil Police on Cooperation In Preventing And Combating Transnational Crime And Capacity Building",
      },
      {
        country: "JEPANG",
        status: "Masih Berlaku",
        title: "Kerjasama dengan Beberapa Lembaga",
        organizations: [
          "JICA (Japan International Cooperation Agency): Memorandum of Cooperation between the Indonesian National Police and the National Police Agency of Japan on Preventing and Combating Transnational Crimes and Police Capacity Building",
          "NPAJ: Memorandum of Cooperation between the Indonesian National Police and the National Police Agency of Japan on Preventing and Combating Transnational Crimes and Police Capacity Building",
        ],
      },
      {
        country: "KAMBOJA",
        status: "Masih Berlaku",
        title:
          "Memorandum of Understanding between the Indonesian National Police of Republic of Indonesia and the Ministry of Interior of the Kingdom of Cambodia on Cooperation in Preventing and Combating Transnational Crimes and Enhancing Capacity Building",
      },
      {
        country: "LAO PDR",
        status: "Masih Berlaku",
        title:
          "Memorandum of Understanding on Preventing and Combating Transnational Crimes and Developing Capacity Building",
      },
      {
        country: "MALAYSIA",
        status: "Masih Berlaku",
        title: "Beberapa Perjanjian Kerjasama",
        organizations: [
          "Memorandum of Understanding on Combating Illicit Trafficking in Narcotic Drugs, Psychotropic Substances, Precursors, Hazardous Materials and Enhancement of Police Cooperation",
          "Memorandum of Understanding between the Government of the Republic of Indonesia and the Government of Malaysia on Police Cooperation in Preventing and Combating Transnational Crimes and Enhancing Capacity Building",
        ],
      },
      {
        country: "PAKISTAN",
        status: "Masih Berlaku",
        title:
          "Memorandum of Understanding between the Government of the Republic of Indonesia and the Government of the Islamic Republic of the Pakistan on Combating International Terrorism",
      },
      {
        country: "SINGAPURA",
        status: "Masih Berlaku",
        title:
          "Memorandum of Understanding between the Indonesian National Police of Republic of Indonesia and the Ministry of Home Affairs of Republic of Singapore on Cooperation in Preventing and Combating Transnational Crimes and Enhancing Capacity Building",
      },
      {
        country: "SRI LANKA",
        status: "Masih Berlaku",
        title:
          "Memorandum of Understanding between the Indonesian National Police of the Republic of Indonesia and the Ministry of Law and Order & Southern Development of the Democratic Socialist Republic of Sri Lanka on Cooperation in Preventing and Combating Transnational Crimes and Capacity Building",
      },
      {
        country: "TIMOR LESTE",
        status: "Masih Berlaku",
        title: "Kerjasama dengan PCIC",
        organizations: [
          "Memorandum of Understanding on Cooperation in Preventing and Combating Transnational Crimes and Developing Police Collaboration",
          "Memorandum of Understanding between the Indonesian National Police and the Scientific Police for Criminal Investigation of Democratic Republic of Timor Leste on Cooperation in the Prevention and eradication on Transnational Crimes and capacity Building",
        ],
      },
      {
        country: "RRT (TIONGKOK)",
        status: "Masih Berlaku",
        title: "Beberapa Perjanjian Kerjasama",
        organizations: [
          "Agreement on Cooperation between the Indonesian National Police of the Republic of Indonesia and the Ministry of Public Security of the People's of the Republic of China",
          "Agreement between the Indonesian National Police of the Republic of Indonesia and the Ministry of Public Security of the People's of the Republic of China on Cooperation in Preventing, Combating Transnational Crime and Capacity Building",
        ],
      },
      {
        country: "TAIWAN",
        status: "Masih Berlaku",
        title:
          "Memorandum of Understanding between the Indonesian Economic and Trade Office to Taipei and the Taipei Economic and Trade Office in Indonesia on the Cooperation in Preventing and Enhancing Capacity Building",
      },
      {
        country: "VIETNAM",
        status: "Masih Berlaku",
        title: "Beberapa Perjanjian Kerjasama",
        organizations: [
          "Memorandum of Understanding on between the Government of the Republic of Indonesia and the Government of the Socialist Republic of Vietnam on Cooperation in Preventing and Combating Crimes",
          "Protocol to Amend, Supplement the Memorandum of Understanding between the Government of the Republic of Indonesia and Government of the Socialist Republic of Vietnam on Cooperation in Preventing and Combating Crimes",
        ],
      },
      {
        country: "YORDANIA",
        status: "Masih Berlaku",
        title:
          "Memorandum of Understanding between the Indonesian National Police of the Republic of Indonesia and the Public Security Directorate of Jordan on Cooperation in Preventing and Combating Transnational Crimes and Enhancing Capacity Building",
      },
    ],
  },
  {
    name: "EROPA",
    countries: [
      {
        country: "BELANDA",
        status: "Masih Berlaku",
        title: "Beberapa Perjanjian Kerjasama",
        organizations: [
          "Memorandum of Understanding between the Indonesian National Police and The Ministry of The Interior and Kingdom Relations of The Netherlands Regarding Education and Training Cooperation",
          "Memorandum of Understanding Between the Indonesian National Police and The Netherlands Police on Preventing and Combating Transnational Crime",
        ],
      },
      {
        country: "JERMAN",
        status: "Masih Berlaku",
        title:
          "Declaration of Intent between the Indonesian National Police and The Federal Ministry of The Interior of The Federal Republic of Germany On Preventing and Combating Transnational Crimes and Capacity Building",
      },
      {
        country: "POLANDIA",
        status: "Masih Berlaku",
        title:
          "Agreement between the Government of The Republic of Indonesia And the Government of The Republic of Poland On Cooperation in Combating Transnational Organized Crime and Other Types of Crime",
      },
      {
        country: "ROMANIA",
        status: "Masih Berlaku",
        title:
          "Agreement between the Government of The Republic of Indonesia And the Government of Romania On Cooperation in Preventing and Combating Transnational Organized Crime, Terrorism and Other Types of Crime",
      },
      {
        country: "SERBIA",
        status: "Masih Berlaku",
        title:
          "Memorandum of Understanding between the Ministry of the Interior of the Republic of Serbia and the National Police of the Republic of Indonesia",
      },
      {
        country: "INGGRIS",
        status: "Masih Berlaku",
        title: "Kerjasama dengan Beberapa Lembaga",
        organizations: [
          "Memorandum of Understanding between the Government of The Republic of Indonesia And the Government of The United Kingdom of Great Britain And Northern Ireland On Police Cooperation in Preventing and Combating Terrorism and Other Transnational Crimes",
          "Coventry University: Letter of Intent between Indonesian Police Science Institute and Coventry University",
          "Buckingham University: Technical Arrangement between the Indonesian National Police and the University of Buckingham, United Kingdom on Cooperation in Enhancing Capacity Building on Intelligence Related Program Development",
        ],
      },
    ],
  },
  {
    name: "OSEANIA",
    countries: [
      {
        country: "AUSTRALIA",
        status: "Masih Berlaku",
        title: "Beberapa Perjanjian Kerjasama",
        organizations: [
          "Arrangement between the Indonesian National Police and the Australian Federal Police on Cooperation in Preventing and Combating Transnational Crimes",
          "Implementing Arrangement between the INP and the AFP on the Cybercrime Cooperation",
          "Implementing Arrangement between the Indonesian National Police and the Australian Federal Police on the Placement of Supporting Officers in the Field of Transnational Crimes",
          "AUSTRALIA (JCLEC): Perubahan Atas Protokol Antara Kepolisian Negara Republik Indonesia (Polri) dan Kepolisian Federal Australia (AFP) Untuk Mendirikan Pusat Kerja Sama Penegakan Hukum Jakarta (JCLEC)",
        ],
      },
      {
        country: "FIJI",
        status: "Proses Perpanjangan",
        title:
          "Memorandum of Understanding between the Indonesian National Police and the Ministry of Defense and National Security of the Republic of Fiji on Cooperation in Preventing and Combating Transnational Crimes and Enhancing Capacity Building",
      },
      {
        country: "SELANDIA BARU",
        status: "Masih Berlaku",
        title:
          "Arrangement between Indonesian National Police and the New Zealand Police on Cooperation in Preventing and Combating Transnational Crimes",
      },
      {
        country: "PAPUA NUGINI",
        status: "Masih Berlaku",
        title:
          "Memorandum of Understanding on Cooperation in Preventing and Combating Transnational Crimes and Capacity Building",
      },
      {
        country: "VANUATU",
        status: "Masih Berlaku",
        title:
          "Memorandum of Understanding between the Indonesian National Police and the Vanuatu Police Force on Cooperation in Preventing and Combating Transnational Crimes and Developing Police Collaboration",
      },
    ],
  },
];
